/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIAPIEmailVerificationRequestRequest,
  APIAPIPasswordResetConfirmRequestRequest,
  APIAPIPasswordResetRequestRequest,
  APIAPITestGetLatestTokenRequestRequest,
  APIAPITokenRequestRequest,
  APIEmailResendRequest,
  APIV1AuthEmailRequestCheckTokenCreate200Response,
  APIV1AuthEmailRequestTestGetLatestTokenCreate200Response,
} from '../models/index';
import {
    APIAPIEmailVerificationRequestRequestFromJSON,
    APIAPIEmailVerificationRequestRequestToJSON,
    APIAPIPasswordResetConfirmRequestRequestFromJSON,
    APIAPIPasswordResetConfirmRequestRequestToJSON,
    APIAPIPasswordResetRequestRequestFromJSON,
    APIAPIPasswordResetRequestRequestToJSON,
    APIAPITestGetLatestTokenRequestRequestFromJSON,
    APIAPITestGetLatestTokenRequestRequestToJSON,
    APIAPITokenRequestRequestFromJSON,
    APIAPITokenRequestRequestToJSON,
    APIEmailResendRequestFromJSON,
    APIEmailResendRequestToJSON,
    APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON,
    APIV1AuthEmailRequestCheckTokenCreate200ResponseToJSON,
    APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseFromJSON,
    APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseToJSON,
} from '../models/index';

export interface V1AuthEmailRequestCheckTokenCreateRequest {
    aPIAPITokenRequestRequest: APIAPITokenRequestRequest;
}

export interface V1AuthEmailRequestEmailResendCreateRequest {
    aPIEmailResendRequest: APIEmailResendRequest;
}

export interface V1AuthEmailRequestEmailVerificationCreateRequest {
    aPIAPIEmailVerificationRequestRequest: APIAPIEmailVerificationRequestRequest;
}

export interface V1AuthEmailRequestPasswordResetConfirmCreateRequest {
    aPIAPIPasswordResetConfirmRequestRequest: APIAPIPasswordResetConfirmRequestRequest;
}

export interface V1AuthEmailRequestPasswordResetRequestCreateRequest {
    aPIAPIPasswordResetRequestRequest: APIAPIPasswordResetRequestRequest;
}

export interface V1AuthEmailRequestTestGetLatestTokenCreateRequest {
    aPIAPITestGetLatestTokenRequestRequest: APIAPITestGetLatestTokenRequestRequest;
}

/**
 * 
 */
export class AuthenticationemailVerificationApi extends runtime.BaseAPI {

    /**
     */
    async v1AuthEmailRequestCheckTokenCreateRaw(requestParameters: V1AuthEmailRequestCheckTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestCheckTokenCreate200Response>> {
        if (requestParameters['aPIAPITokenRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAPITokenRequestRequest',
                'Required parameter "aPIAPITokenRequestRequest" was null or undefined when calling v1AuthEmailRequestCheckTokenCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/check_token/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAPITokenRequestRequestToJSON(requestParameters['aPIAPITokenRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1AuthEmailRequestCheckTokenCreate(requestParameters: V1AuthEmailRequestCheckTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestCheckTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestCheckTokenCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1AuthEmailRequestEmailResendCreateRaw(requestParameters: V1AuthEmailRequestEmailResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestCheckTokenCreate200Response>> {
        if (requestParameters['aPIEmailResendRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIEmailResendRequest',
                'Required parameter "aPIEmailResendRequest" was null or undefined when calling v1AuthEmailRequestEmailResendCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/email_resend/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIEmailResendRequestToJSON(requestParameters['aPIEmailResendRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1AuthEmailRequestEmailResendCreate(requestParameters: V1AuthEmailRequestEmailResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestCheckTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestEmailResendCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1AuthEmailRequestEmailVerificationCreateRaw(requestParameters: V1AuthEmailRequestEmailVerificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestCheckTokenCreate200Response>> {
        if (requestParameters['aPIAPIEmailVerificationRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAPIEmailVerificationRequestRequest',
                'Required parameter "aPIAPIEmailVerificationRequestRequest" was null or undefined when calling v1AuthEmailRequestEmailVerificationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/email_verification/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAPIEmailVerificationRequestRequestToJSON(requestParameters['aPIAPIEmailVerificationRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1AuthEmailRequestEmailVerificationCreate(requestParameters: V1AuthEmailRequestEmailVerificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestCheckTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestEmailVerificationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1AuthEmailRequestPasswordResetConfirmCreateRaw(requestParameters: V1AuthEmailRequestPasswordResetConfirmCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestCheckTokenCreate200Response>> {
        if (requestParameters['aPIAPIPasswordResetConfirmRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAPIPasswordResetConfirmRequestRequest',
                'Required parameter "aPIAPIPasswordResetConfirmRequestRequest" was null or undefined when calling v1AuthEmailRequestPasswordResetConfirmCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/password_reset/confirm/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAPIPasswordResetConfirmRequestRequestToJSON(requestParameters['aPIAPIPasswordResetConfirmRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1AuthEmailRequestPasswordResetConfirmCreate(requestParameters: V1AuthEmailRequestPasswordResetConfirmCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestCheckTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestPasswordResetConfirmCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1AuthEmailRequestPasswordResetRequestCreateRaw(requestParameters: V1AuthEmailRequestPasswordResetRequestCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestCheckTokenCreate200Response>> {
        if (requestParameters['aPIAPIPasswordResetRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAPIPasswordResetRequestRequest',
                'Required parameter "aPIAPIPasswordResetRequestRequest" was null or undefined when calling v1AuthEmailRequestPasswordResetRequestCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/password_reset/request/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAPIPasswordResetRequestRequestToJSON(requestParameters['aPIAPIPasswordResetRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestCheckTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async v1AuthEmailRequestPasswordResetRequestCreate(requestParameters: V1AuthEmailRequestPasswordResetRequestCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestCheckTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestPasswordResetRequestCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Test-only endpoint to get the latest token for an email and optional event type. Only available in non-production environments.  If event is not provided, returns the latest token of any type for the email.
     */
    async v1AuthEmailRequestTestGetLatestTokenCreateRaw(requestParameters: V1AuthEmailRequestTestGetLatestTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIV1AuthEmailRequestTestGetLatestTokenCreate200Response>> {
        if (requestParameters['aPIAPITestGetLatestTokenRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIAPITestGetLatestTokenRequestRequest',
                'Required parameter "aPIAPITestGetLatestTokenRequestRequest" was null or undefined when calling v1AuthEmailRequestTestGetLatestTokenCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/auth/email/request/test/get-latest-token/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIAPITestGetLatestTokenRequestRequestToJSON(requestParameters['aPIAPITestGetLatestTokenRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseFromJSON(jsonValue));
    }

    /**
     * Test-only endpoint to get the latest token for an email and optional event type. Only available in non-production environments.  If event is not provided, returns the latest token of any type for the email.
     */
    async v1AuthEmailRequestTestGetLatestTokenCreate(requestParameters: V1AuthEmailRequestTestGetLatestTokenCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIV1AuthEmailRequestTestGetLatestTokenCreate200Response> {
        const response = await this.v1AuthEmailRequestTestGetLatestTokenCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
